module.exports = __webpack_public_path__ + "assets/img/coin-gct-bj-3.b92941dc.png";